import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-skill-fh",
  "use": "icon-skill-fh-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-skill-fh\">\n\t<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 20s2-1.5 4.5-1.5c1.508 0 2.834.546 3.648.979c.364.193.852-.067.852-.479V6.5a.89.89 0 0 0-.417-.774C19.871 5.293 18.318 4.5 16.5 4.5C14 4.5 12 6 12 6s-2-1.5-4.5-1.5c-1.817 0-3.37.793-4.083 1.226A.89.89 0 0 0 3 6.5V19c0 .412.488.672.851.479c.815-.433 2.141-.979 3.649-.979C10 18.5 12 20 12 20m0-14v1m0 13v-2m4-5l.255.745L17 14l-.745.255L16 15l-.255-.745L15 14l.745-.255zM9 9l.13.378a4 4 0 0 0 2.492 2.493L12 12l-.378.13a4 4 0 0 0-2.493 2.492L9 15l-.13-.378a4 4 0 0 0-2.492-2.493L6 12l.378-.13a4 4 0 0 0 2.493-2.492z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/skill-fh.svg
// module id = wD2Q
// module chunks = 10